import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  fetchDaycareSignups(date) {
    let url = buildUrl("daycare/signups/" + date)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  fetchDaycareStatistic(start, end) {
    let url = buildUrl("daycare/signups/statistic?start=" + start + "&end=" + end)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  signupDaycareAdmin(data) {
    let url = buildUrl("businesshours/daycare/admin/signup")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  signupDaycare(data) {
    let url = buildUrl("businesshours/daycare/signup")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchBusinessHours(type) {
    let url = buildUrl("businesshours/" + type)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateBusinessHours(data) {
    let url = buildUrl("businesshours")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
}
